import { TypePolicies } from '@apollo/client';
import { CapaQuotationUserOutput } from '@generated/graphql';
import { store } from '@store';
import { updateClient } from '@modules/client';

const fetchMyQuotationUser: TypePolicies = {
  Query: {
    fields: {
      fetchMyPaymentDataByQuotationUser: {
        keyArgs: false,
        merge(_, incoming: CapaQuotationUserOutput) {
          if (!incoming?.data) return;

          store.dispatch(updateClient(incoming?.data));

          return incoming;
        }
      }
    }
  }
};

export default fetchMyQuotationUser;
